import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showTokenExpiredAlert, getConfig, authHeader, getCustId, isApiSuccess } from "utils";

// GET subscriber/purchasedHistory/{custId} -> dataList
export const purchaseList = createAsyncThunk('purchase/list', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `subscriber/purchasedHistory/${getCustId()}`,
            headers: authHeader()
        })
        return res
    } catch (error) {
        return error.response
    }
})

const purchase = createSlice({
    name: 'purchase',
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(purchaseList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(purchaseList.fulfilled, (state, action) => {
            state.loading = false;
            if (isApiSuccess(action?.payload)) {
                state.list = action.payload.data.dataList || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else {
                state.list = []
            }
        });
        builder.addCase(purchaseList.rejected, (state) => {
            state.loading = false;
        });
    }
})

export default purchase.reducer;
